

import * as React from "react";
import { Outlet } from "react-router-dom";

import { AuthGuard } from "@/components/auth/auth-guard";
import { Layout as DashboardLayout } from "@/components/scadadashboard/layout/layout";

import { FeatureGuard } from "../components/feature/feature-guard";

export const route = {
    path: "dashboard",
    element: (
        <AuthGuard>
            <DashboardLayout>
                <Outlet />
            </DashboardLayout>
        </AuthGuard>
    ),
    children: [
        {
            index: true,
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/overview");

                const Component = () => (
                    <FeatureGuard feature="overview:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "devices/",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/list");

                const Component = () => (
                    <FeatureGuard feature="device:list:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "devices/:deviceId",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/details");

                const Component = () => (
                    <FeatureGuard feature="device:overview:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "devices/:deviceId/primaryData/general",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/primaryData/general");

                const Component = () => (
                    <FeatureGuard feature="device:primaryData:general:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "devices/:deviceId/primaryData/contacts",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/primaryData/contacts/list");

                const Component = () => (
                    <FeatureGuard feature="device:primaryData:contact:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "devices/:deviceId/primaryData/contacts/new",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/primaryData/contacts/contact");

                const Component = () => (
                    <FeatureGuard feature="device:primaryData:contact:add">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "devices/:deviceId/primaryData/contacts/:contactUuid/update",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/primaryData/contacts/contact");

                const Component = () => (
                    <FeatureGuard feature="device:primaryData:contact:update">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },

        {
            path: "devices/:deviceId/battery",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/battery");

                const Component = () => (
                    <FeatureGuard feature="device:battery:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "devices/:deviceId/inverter",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/inverter");

                const Component = () => (
                    <FeatureGuard feature="device:inverter:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "devices/:deviceId/wallbox",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/wallbox");

                const Component = () => (
                    <FeatureGuard feature="device:wallbox:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "devices/:deviceId/events",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/events");

                const Component = () => (
                    <FeatureGuard feature="event:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "devices/:deviceId/connections",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/connections");
                const Component = () => (
                    <FeatureGuard feature="externconnections:show">
                        <Page />
                    </FeatureGuard>
                );
                return { Component };
            },
        },
        {
            path: "devices/:deviceId/auxiliary",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/auxData");
                const Component = () => (
                    <FeatureGuard feature="aux:show">
                        <Page />
                    </FeatureGuard>
                );
                return { Component };
            },
        },
        {
            path: "devices/:deviceId/singleLineDiagram",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/sld");
                const Component = () => (
                    <FeatureGuard feature="sld:show">
                        <Page />
                    </FeatureGuard>
                );
                return { Component };
            },
        },
        {
            path: "devices/:deviceId/control",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/control");
                const Component = () => (
                    <FeatureGuard feature="control:show">
                        <Page />
                    </FeatureGuard>
                );
                return { Component };
            },
        },

        {
            path: "devices/:deviceId/feature",            
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/devices/featureRender");
                const Component = () => (
                    //<FeatureGuard feature="control:show">
                        <Page />
                    //</FeatureGuard>
                );
                return { Component };
            },
        },


        //{
        //    path: "devices/:deviceId/settings",
        //    lazy: async () => {
        //        const { Page } = await import("@/pages/scadadashboard/devices/settings");
        //        return { Component: Page };
        //    },
        //},
        //{
        //    path: "devices/:deviceId/information",
        //    lazy: async () => {
        //        const { Page } = await import("@/pages/scadadashboard/devices/information");
        //        return { Component: Page };
        //    },
        //},
        {
            path: "/dashboard/user/account",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/user/account");

                const Component = () => (
                    <FeatureGuard feature="user:account:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "/dashboard/user/notifications",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/user/notifications");

                const Component = () => (
                    <FeatureGuard feature="user:notifications:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "/dashboard/cases",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/cases/list");

                const Component = () => (
                    <FeatureGuard feature="case:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "/dashboard/devices/:deviceId/cases",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/cases/list");

                const Component = () => (
                    <FeatureGuard feature="case:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "/dashboard/cases/new",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/cases/case");

                const Component = () => (
                    <FeatureGuard feature="case:new">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "/dashboard/devices/:deviceId/cases/new",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/cases/case");

                const Component = () => (
                    <FeatureGuard feature="case:new">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "/dashboard/cases/:caseId/update",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/cases/case");

                const Component = () => (
                    <FeatureGuard feature="case:update">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "/dashboard/devices/:deviceId/cases/:caseId/update",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/cases/case");

                const Component = () => (
                    <FeatureGuard feature="case:update">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },

        //{
        //    path: "/dashboard/cases/:caseId/closed",
        //    lazy: async () => {
        //        const { Page } = await import("@/pages/scadadashboard/cases/case");
        //        return { Component: Page };
        //    },
        //},
        //{
        //    path: "devices/:deviceId/cases/:caseId/closed",
        //    lazy: async () => {
        //        const { Page } = await import("@/pages/scadadashboard/cases/case");
        //        return { Component: Page };
        //    },
        //},

        //TODO: muss ngepasst werden !!!
        {
            path: "/dashboard/reports/operations",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/reports/operations/list");
                return { Component: Page };
            },
        },
        {
            path: "devices/:deviceId/operations",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/reports/operations/list");
                return { Component: Page };
            },
        },
        {
            path: "/dashboard/reports/operations/new",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/reports/operations/operation");
                return { Component: Page };
            },
        },
        {
            path: "devices/:deviceId/operations/new",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/reports/operations/operation");
                return { Component: Page };
            },
        },
        {
            path: "/dashboard/reports/operations/:operationId/update",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/reports/operations/operation");
                return { Component: Page };
            },
        },
        {
            path: "devices/:deviceId/operations/:operationId/update",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/reports/operations/operation");
                return { Component: Page };
            },
        },
        {
            path: "/dashboard/reports/monthly-reports",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/reports/monthly");
                return { Component: Page };
            },
        },
        {
            path: "/dashboard/favorites",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/favorites/list");

                const Component = () => (
                    <FeatureGuard feature="case:show">
                        <Page />
                    </FeatureGuard>
                );

                return { Component };
            },
        },
        {
            path: "workspace/usermanagement",
            lazy: async () => {
                const { Page } = await import(
                    "@/pages/scadadashboard/workspace/userManagement/list"
                );

                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard"
                );

                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:users:show">
                            <Page />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );

                return { Component };
            },
        },
        {
            path: "/dashboard/workspace/usermanagement/new",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/workspace/userManagement/user"
                );

                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard");

                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:users:add">
                            <Page />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );

                return { Component };
            },
        },

        {
            path: "/dashboard/workspace/usermanagement/:uuid/update",
            lazy: async () => {
                const { Page } = await import("@/pages/scadadashboard/workspace/userManagement/user"
                );

                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard");

                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:users:update">
                            <Page />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );

                return { Component };
            },
        },
        {
            path: "workspace/clients",
            lazy: async () => {
                const { Page } = await import(
                    "@/pages/scadadashboard/workspace/clients/list"
                );

                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard"
                );

                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:mandanten:show">
                            <Page />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );

                return { Component };
            },
        },
        {
            path: "workspace/locations",
            lazy: async () => {
                const { Page } = await import(
                    "@/pages/scadadashboard/workspace/locations/list"
                );

                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard"
                );

                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:locations:show">
                            <Page />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );

                return { Component };
            },
        },
        {
            path: "workspace/locations/new",
            lazy: async () => {
                const { Page } = await import(
                    "@/pages/scadadashboard/workspace/locations/location"
                );

                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard");

                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:locations:add">
                            <Page type="new" />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );

                return { Component };
            },
        },
        {
            path: "workspace/locations/:locationUuid/update",
            lazy: async () => {
                const { Page } = await import(
                    "@/pages/scadadashboard/workspace/locations/location"
                );

                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard");

                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:locations:update">
                            <Page type="update" />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );

                return { Component };
            },
        },
        {
            path: "workspace/devices",
            lazy: async () => {
                const { Page } = await import(
                    "@/pages/scadadashboard/workspace/devices/list"
                );

                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard"
                );

                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:devices:show">
                            <Page />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );

                return { Component };
            },
        },
        {
            path: "workspace/devices/new",
            lazy: async () => {
                const { Page } = await import(
                    "@/pages/scadadashboard/workspace/devices/device"
                );
                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard"
                );
                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:devices:add">
                            <Page type="new" />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );
                return { Component };
            },

        },
        {
            path: "workspace/devices/:deviceUuid/update",
            lazy: async () => {
                const { Page } = await import(
                    "@/pages/scadadashboard/workspace/devices/device"
                );

                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard");

                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:devices:update">
                            <Page type="update" />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );
                return { Component };
            },
        },
        {
            path: "workspace/devicesGroups",
            lazy: async () => {
                const { Page } = await import(
                    "@/pages/scadadashboard/workspace/devicesGroups/list"
                );

                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard"
                );

                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:groups:show">
                            <Page />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );

                return { Component };
            },
        },
        {
            path: "workspace/devicesGroups/new",
            lazy: async () => {
                const { Page } = await import(
                    "@/pages/scadadashboard/workspace/devicesGroups/devicesGroup"
                );
                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard"
                );
                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:groups:add">
                            <Page type="new" />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );
                return { Component };
            },

        },
        {
            path: "workspace/devicesGroups/:groupUuid/update",
            lazy: async () => {
                const { Page } = await import(
                    "@/pages/scadadashboard/workspace/devicesGroups/devicesGroup"
                );

                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard");

                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="management:groups:update">
                            <Page type="update" />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );
                return { Component };
            },
        },
        {
            path: "workspace/topicMetrics",
            lazy: async () => {
                const { Page } = await import(
                    "@/pages/scadadashboard/workspace/topicMetrics/list"
                );

                const { WorkspaceGuard } = await import("../components/workspace/workspace-guard"
                );

                const Component = () => (
                    <WorkspaceGuard allowed={["workspaceB"]}>
                        <FeatureGuard feature="billing:topics:show">
                            <Page />
                        </FeatureGuard>
                    </WorkspaceGuard>
                );

                return { Component };
            },
        },
    ],
};
